/*
 * Corval replica: comportamento dos apps da referência recriados no tema.
 * - Carrinho lateral (UpCart): shadow DOM com o HTML de sections/mini-cart.liquid.
 * - Oferta da PDP (MoonBundle): carteira + brindes, quantidade do Tracker.
 * Todo o JS é por delegação para sobreviver aos re-renders do Focal.
 */
(() => {
  const root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
  const TIMER_KEY = 'crv-cart-timer-end';
  const TIMER_SECONDS = 420;

  /* ------------------------------------------------------------ carrinho */
  const Cart = {
    host: null,
    shadow: null,
    isOpen: false,
    slide: 0,

    init() {
      this.host = document.createElement('div');
      this.host.id = 'upCart';
      document.body.appendChild(this.host);
      this.shadow = this.host.attachShadow({ mode: 'open' });
      this.renderFrom(document);
      this.shadow.addEventListener('click', (e) => this.onClick(e));
      this.shadow.addEventListener('change', (e) => this.onChange(e));
      this.shadow.addEventListener('submit', (e) => this.onSubmit(e));
      setInterval(() => this.tick(), 1000);
    },

    renderFrom(doc) {
      const tpl = doc.querySelector('#crv-upcart-tpl');
      if (!tpl) return;
      const frag = tpl.content ? tpl.content.cloneNode(true) : document.createRange().createContextualFragment(tpl.innerHTML);
      this.shadow.replaceChildren(frag);
      this.applyState();
      this.tick();
      this.moveSlider(false);
    },

    async refresh(html) {
      if (!html) {
        const res = await fetch(`${root}?sections=mini-cart`);
        html = (await res.json())['mini-cart'];
      }
      const div = document.createElement('div');
      div.innerHTML = html;
      this.renderFrom(div);
    },

    applyState() {
      const popup = this.shadow.querySelector('#UpcartPopup');
      if (!popup) return;
      popup.classList.toggle('upcartPopupShow', this.isOpen);
      this.shadow.querySelectorAll('#CartPopup, #UpcartPopupBackDrop').forEach((el) => el.classList.toggle('styles_active__', this.isOpen));
      document.documentElement.style.overflow = this.isOpen ? 'hidden' : '';
    },

    open() {
      if (!sessionStorage.getItem(TIMER_KEY)) this.resetTimer();
      this.isOpen = true;
      this.applyState();
    },

    close() {
      this.isOpen = false;
      this.applyState();
    },

    resetTimer() {
      try { sessionStorage.setItem(TIMER_KEY, String(Date.now() + TIMER_SECONDS * 1000)); } catch (e) {}
    },

    tick() {
      const el = this.shadow && this.shadow.querySelector('[data-crv-timer]');
      if (!el) return;
      let end = 0;
      try { end = parseInt(sessionStorage.getItem(TIMER_KEY) || '0', 10); } catch (e) {}
      if (!end) { this.resetTimer(); end = Date.now() + TIMER_SECONDS * 1000; }
      let left = Math.max(0, Math.round((end - Date.now()) / 1000));
      if (left === 0) { this.resetTimer(); left = TIMER_SECONDS; }
      el.textContent = String(Math.floor(left / 60)).padStart(2, '0') + ':' + String(left % 60).padStart(2, '0');
    },

    moveSlider(animate = true) {
      const ul = this.shadow.querySelector('[data-crv-slider]');
      if (!ul) return;
      const real = ul.children.length - 2;
      if (real < 1) return;
      ul.style.transitionDuration = animate ? '350ms' : '0ms';
      ul.style.transform = `translate3d(${-(this.slide + 1) * 100}%, 0px, 0px)`;
      if (animate && (this.slide < 0 || this.slide >= real)) {
        setTimeout(() => {
          this.slide = (this.slide + real) % real;
          this.moveSlider(false);
        }, 360);
      }
    },

    async change(line, quantity) {
      const res = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity, sections: ['mini-cart'] })
      });
      const cart = await res.json();
      this.broadcast(cart, false);
    },

    async add(items) {
      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items, sections: ['mini-cart'] })
      });
      const json = await res.json();
      const cart = await (await fetch(`${root}cart.js`)).json();
      cart.sections = json.sections;
      this.broadcast(cart, true);
      return res.ok;
    },

    broadcast(cart, openMiniCart) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart, openMiniCart } }));
    },

    onClick(e) {
      const t = e.target;
      if (t.closest('[data-crv-close]')) return this.close();
      const slideBtn = t.closest('[data-crv-slide]');
      if (slideBtn) {
        this.slide += parseInt(slideBtn.dataset.crvSlide, 10);
        return this.moveSlider(true);
      }
      const qtyBtn = t.closest('[data-crv-qty]');
      if (qtyBtn) {
        const row = qtyBtn.closest('[data-line]');
        return this.change(parseInt(row.dataset.line, 10), parseInt(qtyBtn.dataset.crvQty, 10));
      }
    },

    onChange(e) {
      const input = e.target.closest('[data-crv-qty-input]');
      if (!input) return;
      const row = input.closest('[data-line]');
      this.change(parseInt(row.dataset.line, 10), Math.max(0, parseInt(input.value || '0', 10)));
    },

    onSubmit(e) {
      const form = e.target.closest('[data-crv-upsell]');
      if (!form) return;
      e.preventDefault();
      const id = parseInt(form.querySelector('[name="productVariant"]').value, 10);
      this.add([{ id, quantity: 1 }]);
    }
  };

  /* ------------------------------------------------------------ oferta (MoonBundle) */
  const CHECK_SVG = '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 8L6.5 11.5L13 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>';

  const Bundle = {
    selectedQty(bundle) {
      const active = bundle.querySelector('.moonbundle-option-active');
      const wrap = active && active.closest('[data-crv-qty]');
      return wrap ? parseInt(wrap.dataset.crvQty, 10) : 1;
    },

    items(bundle, form) {
      const kind = bundle.dataset.crvBundle;
      if (kind === 'wallet-gifts') {
        const main = parseInt(form.querySelector('input[name="id"]').value, 10);
        const items = [{ id: main, quantity: 1 }];
        bundle.querySelectorAll('[data-crv-gift]').forEach((s) => items.push({ id: parseInt(s.value, 10), quantity: 1 }));
        bundle.querySelectorAll('[data-crv-gift-fixed]').forEach((s) => items.push({ id: parseInt(s.dataset.crvGiftFixed, 10), quantity: 1 }));
        // A Shopify lista o último item do lote primeiro; a ref mostra carteira, coffret, porta-chaves.
        return [items[1], items[2], items[0]].filter(Boolean);
      }
      if (kind === 'wallet-b') {
        const qty = this.selectedQty(bundle);
        const active = bundle.querySelector(`[data-crv-qty="${qty}"]`);
        const items = [];
        active.querySelectorAll('[data-crv-wallet]').forEach((dd) => {
          const id = parseInt(dd.dataset.variantId, 10);
          const same = items.find((i) => i.id === id);
          if (same) same.quantity += 1;
          else items.push({ id, quantity: 1 });
        });
        const gifts = [];
        bundle.querySelectorAll('[data-crv-gift-fixed]').forEach((g) => gifts.push({ id: parseInt(g.dataset.crvGiftFixed, 10), quantity: qty }));
        bundle.querySelectorAll('[data-crv-gift]').forEach((g) => gifts.push({ id: parseInt(g.value, 10), quantity: qty }));
        // Mesma ordem no carrinho da ref: carteira(s), coffret, porta-chaves (a Shopify inverte o lote).
        return [gifts[1], gifts[0], ...items.reverse()].filter(Boolean);
      }
      const active = bundle.querySelector('.moonbundle-option-active');
      const counts = {};
      active.querySelectorAll('[data-crv-unit]').forEach((s) => { counts[s.value] = (counts[s.value] || 0) + 1; });
      return Object.entries(counts).map(([id, quantity]) => ({ id: parseInt(id, 10), quantity }));
    },

    selectOption(option) {
      const bundle = option.closest('.crv-bundle');
      bundle.querySelectorAll('.moonbundle-option').forEach((o) => o.classList.toggle('moonbundle-option-active', o === option));
      if (bundle.dataset.crvBundle !== 'wallet-b') return;
      bundle.querySelectorAll('.moonbundle-bullet-checkmark').forEach((b) => {
        const on = b.closest('.moonbundle-option') === option;
        b.classList.toggle('checked', on);
        b.innerHTML = on ? CHECK_SVG : '';
      });
      const two = this.selectedQty(bundle) === 2;
      bundle.querySelectorAll('[data-crv-x2]').forEach((x) => { x.hidden = !two; });
      bundle.querySelectorAll('[data-crv-ship]').forEach((el) => { el.hidden = (el.dataset.crvShip === 'on') !== two; });
    },

    pickColor(btn) {
      const dd = btn.closest('[data-crv-dd]');
      dd.querySelector('[data-crv-dd-menu]').hidden = true;
      dd.querySelector('.moonbundle-dropdown-button').setAttribute('aria-expanded', 'false');
      dd.querySelector('[data-crv-dd-label]').textContent = btn.dataset.value;
      dd.querySelector('[data-crv-dd-swatch]').style.cssText = btn.querySelector('.moonbundle-swatch-indicator').style.cssText;
      dd.querySelectorAll('.moonbundle-dropdown-option').forEach((o) => o.classList.toggle('selected', o === btn));
      if (btn.dataset.variantId) dd.dataset.variantId = btn.dataset.variantId;
      // Na oferta de 2 carteiras cada linha tem sua cor; só a opção de 1 carteira mexe na galeria.
      const wrap = dd.closest('[data-crv-qty]');
      if (dd.hasAttribute('data-crv-wallet') && wrap && wrap.dataset.crvQty !== '1') return;
      // Troca a variante no seletor do Focal (escondido, como na referência): galeria, preço e id do formulário.
      const radio = document.querySelector(`variant-picker input[value="${btn.dataset.valueId}"]`);
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  };

  document.addEventListener('click', (e) => {
    const t = e.target;
    // Ícone do carrinho no header: abre o drawer (o app substitui o mini-cart do tema).
    const cartLink = t.closest('a[aria-controls="mini-cart"], [data-action="toggle-drawer"][aria-controls="mini-cart"], a.header__cart-toggle');
    if (cartLink) {
      e.preventDefault();
      e.stopImmediatePropagation();
      Cart.open();
      return;
    }
    const ddBtn = t.closest('.crv-bundle .moonbundle-dropdown-button');
    if (ddBtn) {
      const menu = ddBtn.parentElement.querySelector('[data-crv-dd-menu]');
      menu.hidden = !menu.hidden;
      ddBtn.setAttribute('aria-expanded', String(!menu.hidden));
      return;
    }
    const ddOpt = t.closest('.crv-bundle .moonbundle-dropdown-option');
    if (ddOpt) return Bundle.pickColor(ddOpt);
    if (!t.closest('.crv-bundle [data-crv-dd]')) {
      document.querySelectorAll('.crv-bundle [data-crv-dd-menu]').forEach((m) => { m.hidden = true; });
    }
    const opt = t.closest('.crv-bundle .moonbundle-option');
    if (opt && !t.closest('select')) Bundle.selectOption(opt);
  }, true);

  // Botão "Ajouter au panier" da PDP com oferta: adiciona o conjunto da oferta.
  // Cortado já no clique: só barrar o submit deixava o ProductForm do Focal adicionar a carteira de novo.
  const bundleFor = (form) => {
    if (!form || !form.matches || !form.matches('form[is="product-form"]')) return null;
    if (form.closest('quick-buy-drawer, quick-buy-popover')) return null;
    const wrap = form.closest('.product-form__buy-buttons');
    return wrap && wrap.querySelector('.crv-bundle');
  };
  const addBundle = (e, form, bundle) => {
    e.preventDefault();
    e.stopImmediatePropagation();
    const btns = form.querySelectorAll('[type="submit"]');
    if (btns[0] && btns[0].getAttribute('aria-busy') === 'true') return;
    btns.forEach((b) => b.setAttribute('aria-busy', 'true'));
    Cart.add(Bundle.items(bundle, form)).finally(() => btns.forEach((b) => b.removeAttribute('aria-busy')));
  };
  document.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest('[type="submit"]');
    const form = btn && btn.form;
    const bundle = bundleFor(form);
    if (bundle) addBundle(e, form, bundle);
  }, true);
  document.addEventListener('submit', (e) => {
    const bundle = bundleFor(e.target);
    if (bundle) addBundle(e, e.target, bundle);
  }, true);

  document.documentElement.addEventListener('cart:refresh', (e) => {
    const d = e.detail || {};
    const html = d.cart && d.cart.sections && d.cart.sections['mini-cart'];
    Cart.refresh(html).then(() => { if (d.openMiniCart) Cart.open(); });
  });

  // UpCart abre a cada adição (openOnAddToCart), inclusive dentro do quick-buy do Focal.
  let openNext = false;
  document.addEventListener('variant:added', () => { openNext = true; });
  document.documentElement.addEventListener('cart:refresh', () => {
    if (!openNext) return;
    openNext = false;
    setTimeout(() => Cart.open(), 50);
  });

  // Seletor de cor do Focal (visível nas carteiras, como na ref) → mesma cor na oferta de 1 carteira.
  document.addEventListener('variant:changed', (e) => {
    const v = e.detail && e.detail.variant;
    const form = e.target && e.target.closest && e.target.closest('.product-form');
    const bundle = form && form.querySelector('.crv-bundle');
    if (!v || !bundle) return;
    const dd = bundle.querySelector('[data-crv-qty="1"] [data-crv-dd]') || bundle.querySelector('[data-crv-dd]');
    const btn = dd && dd.querySelector(`.moonbundle-dropdown-option[data-value="${CSS.escape(v.option1)}"]`);
    if (!btn || btn.classList.contains('selected')) return;
    dd.querySelector('[data-crv-dd-label]').textContent = btn.dataset.value;
    dd.querySelector('[data-crv-dd-swatch]').style.cssText = btn.querySelector('.moonbundle-swatch-indicator').style.cssText;
    dd.querySelectorAll('.moonbundle-dropdown-option').forEach((o) => o.classList.toggle('selected', o === btn));
    if (btn.dataset.variantId) dd.dataset.variantId = btn.dataset.variantId;
  });

  // Contagem da oferta (MoonBundle, modo diário): até a meia-noite local.
  const offerTimer = () => {
    const els = document.querySelectorAll('.crv-bundle [data-crv-tm]');
    if (!els.length) return;
    const now = new Date();
    const end = new Date(now); end.setHours(24, 0, 0, 0);
    const left = Math.max(0, Math.floor((end - now) / 1000));
    const parts = { h: Math.floor(left / 3600), m: Math.floor(left / 60) % 60, s: left % 60 };
    els.forEach((el) => { el.textContent = String(parts[el.dataset.crvTm]).padStart(2, '0'); });
  };
  offerTimer();
  setInterval(offerTimer, 1000);

  // Judge.me (só visual): classe de tamanho pela largura do widget, como o app faz.
  const jdgmSize = () => document.querySelectorAll('.jdgm-review-widget').forEach((w) => {
    const width = w.getBoundingClientRect().width;
    w.classList.toggle('jdgm-review-widget--small', width < 450);
    w.classList.toggle('jdgm-review-widget--medium', width >= 450 && width < 650);
  });
  window.addEventListener('resize', jdgmSize);
  document.addEventListener('DOMContentLoaded', jdgmSize);
  jdgmSize();

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => Cart.init());
  else Cart.init();
  window.CrvCart = Cart;
})();
